import { ReactComponent as Notes } from "./svg/notes.svg";

export const IconNotes = () => <Notes />;
